@if (form) {
  <form [formGroup]="form">
    <label>{{ 'SET_PW_TITLE' | translate }}</label>
    <em-input
      [label]="'ACCOUNT_NEW_PASSWORD_LABEL' | translate"
      matInput
      type="password"
      formControlName="password"
      >
      <em-error>
        @if (form?.get('password')?.hasError('required')) {
          {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
        }
        @if (form?.get('password')?.hasError('minlength')) {
          {{ 'ACCOUNT_NEW_PASSWORD_TOO_SHORT' | translate }}
        }
      </em-error>
    </em-input>
  </form>
}
